module.exports = [{"Key":"menu_title","Value":{"Korean":"엔닷캐드 메뉴들을 만나보세요!","English":"Here're the menus of NdotCAD!"}},{"Key":"menu_edit","Value":{"Korean":"편집","English":"Edit"}},{"Key":"menu_tool","Value":{"Korean":"도구","English":"Tool"}},{"Key":"menu_view","Value":{"Korean":"보기","English":"View"}},{"Key":"menu_advanced","Value":{"Korean":"고급","English":"Advanced"}},{"Key":"menu_setting","Value":{"Korean":"설정","English":"Setting"}}]


//////////////////
// WEBPACK FOOTER
// ./src/assets/language/menu.json
// module id = 7zj0
// module chunks = 1